import { TopHeader, CTNavbar, CTSearchView, ApplicationAnnouncement } from '../components';

import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { UsersList, UsersReportsList } from "pageComponents";



const AdminLandingPage = () => {

  const [isProviderReports, setIsProviderReports] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [navItems, setNavItems] = useState([]);
  const MenuData = useSelector((state) => state.apiService.menuItem);
  const userData = useSelector((state) => state.apiService.login);
  const token = userData?.Token || '';
  const params = { token, user_id: userData.user_id };


  const [activeMenuItem, setActiveMenuItem] = useState
    ({
      showUsersList: false,
      showUserReports: false,
    })

  const navigate = useNavigate();
  const [selectedPatientName, setSelectedPatientName] = useState('');

  useEffect(() => {
    console.log(MenuData, "typessss")

    if (MenuData && Array.isArray(MenuData)) {
      const updatedNavItems = MenuData.map(item => ({
        menu_id: item.menu_id,
        title: item.title || "Untitled",
        url: item.url || "#",
        parent_id: item.parent_id || null,
        sort_order: item.sort_order || 0,
        type: item.type || ""
      }));
      setNavItems(updatedNavItems);
    }
  }, [MenuData])

  const setActiveMenuItems = (event) => {

    const newActiveMenuItem = {
      showUsersList: event.menu_id === 10,
      showUserReports: event.menu_id === 11,

    };

    setActiveMenuItem(newActiveMenuItem);
    console.log(activeMenuItem, "newActiveMenuItem")
  }
  const handlePatientSummaryClick = (userId, name) => {

    setIsProviderReports(true);
    setSelectedPatientName(name);


  }
  const handleBackToRequestAccess = () => {
    setIsProviderReports(false);
    setActiveTab('Request Access');

  };
  return (
    <>

      <div className="fixed-top" style={{ verticalAlign: "center", flex: 1, alignContent: 'center', alignItems: 'center' }}>
        <div className="shadow-lg">
          <TopHeader />
        </div>
        <div className="py-2 mx-4">
          <CTNavbar
            navItems={navItems}
            activeTab={activeTab}
            setDashboard={setActiveMenuItems}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>
      <div style={{
        height: "75px"
      }}></div>
      <div className='container-fluid mt-5 px-3'>
                {/* Show announcement banner for admin */}
                {/* <ApplicationAnnouncement /> */}
        <div className='px-3'>
          {activeMenuItem.showUsersList && <div className='py-3'><UsersList /></div>}
          {activeMenuItem.showUserReports && <UsersReportsList />}
        </div>
      </div>
    </>
  )
}

export default AdminLandingPage;